import { INIT_BTAX_DATA } from "./actionTypes";

export const setBtaxData = (btaxData) => {
  return (dispatch, getstate) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: INIT_BTAX_DATA, payload: btaxData });
      resolve();
    });
  };
};
